import { CtaBlock } from '@design-system/cta-block';
import React, { FC } from 'react';

import { CardCTAProps } from '../../models';

export const CardCTA: FC<CardCTAProps> = ({ ctaBlock }) => (
  <CtaBlock {...ctaBlock} className="cds-card__cta" />
);
